// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-tree-container {
  max-width: 97.8%;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  color: #859296;
  font-size: 14px;
  margin-left: 8px;
  padding: 20px;
  background-color: #FFF;
  height: 80vh;
}
.base-tree-container .tree-header {
  display: flex;
  padding: 5px;
  height: 38px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.base-tree-container .tree-header .tree-column {
  color: #6E6E6E;
  vertical-align: bottom;
  font-size: 12px;
  font-weight: 500;
  align-items: center;
}
.base-tree-container .primary {
  font-size: 16px;
  color: #055C8D;
  font-weight: 600;
}
.base-tree-container .secondary {
  font-size: 14px;
  color: #055C8D;
}
.base-tree-container .tree-wrapper {
  flex: 1;
  max-height: calc(80vh - 0.2rem);
}
.base-tree-container .tree-node-wrapper {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 0.2rem;
  display: flex;
  flex-direction: row;
}
.base-tree-container .node-content-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  flex: 1;
  margin-right: 0.25rem;
}
.base-tree-container .tree-header {
  width: 100%;
}
.base-tree-container .tree-column-wrapper, .base-tree-container .tree-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}
.base-tree-container .tree-column-wrapper span, .base-tree-container .tree-header span {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.base-tree-container .tree-column-wrapper .tree-column, .base-tree-container .tree-header .tree-column {
  flex-grow: 1;
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
  align-items: center;
}
.base-tree-container .tree-column-wrapper .tree-column:first-child, .base-tree-container .tree-header .tree-column:first-child {
  overflow: hidden;
  margin-right: auto;
  flex-grow: 0;
  min-width: 0px;
}
.base-tree-container .tree-column-wrapper .tree-column:first-child span, .base-tree-container .tree-header .tree-column:first-child span {
  white-space: initial;
}
.base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
  flex-grow: 0;
  flex-shrink: 0;
  align-items: stretch;
  width: 600px;
  padding-top: 5px;
}
@media (max-width: 1800px) {
  .base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
    width: 500px;
  }
}
@media (max-width: 1600px) {
  .base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
    width: 400px;
  }
}
@media (max-width: 1439px) {
  .base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
    width: 300px;
  }
}
@media (max-width: 1024px) {
  .base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
    width: 200px !important;
  }
}
@media (max-width: 768px) {
  .base-tree-container .tree-column-wrapper .tree-column:not(:first-child), .base-tree-container .tree-header .tree-column:not(:first-child) {
    display: 100px !important;
  }
}
.base-tree-container .tree-column-wrapper:last-child, .base-tree-container .tree-header:last-child {
  overflow: hidden;
  margin-right: auto;
  flex-shrink: 1;
  min-width: 150px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
